import '../helpers/style';

;$(function() {

	var page = {};
	page.images = $('.image-block');
	page.list = $('.image-block__list');
	page.pagination = $('.image-block__pagination');

	var action = {};
	action.images = {};
	action.images.lazyLoad = img => {
		if (img.data('src')) {
			// img.addStyle({'background-image': "url('" + img.data('src') + "')"});
			img.attr('src', img.data('src'));
			img.removeAttr('data-src');
		}
	}
	action.images.onMousemove = function(e) {
		if ($(window).width() < 768) return;

		let _ = $(this);

		let imageItems = _.find('.image-block__item');
		let squareWidth = _.outerWidth() / imageItems.length;
		let targetIndex = Math.floor(e.offsetX / squareWidth);

		if (!imageItems.eq(targetIndex).hasClass('image-block__item_active')) {
			let paginationItems = _.find('.image-block__pagination-item');

			_.find('.image-block__item_active').removeClass('image-block__item_active');
			imageItems.eq(targetIndex).addClass('image-block__item_active');

			_.find('.image-block__pagination-item_active').removeClass('image-block__pagination-item_active');
			paginationItems.eq(targetIndex).addClass('image-block__pagination-item_active');

			// lazy load
			action.images.lazyLoad(imageItems.eq(targetIndex).find('.image-block__image'));
		}
	}
	action.images.onMouseleave = function() {
		if ($(window).width() < 768) return;

		let _ = $(this);

		_.find('.image-block__item_active').removeClass('image-block__item_active');
		_.find('.image-block__item').eq(0).addClass('image-block__item_active');

		_.find('.image-block__pagination-item_active').removeClass('image-block__pagination-item_active');
		_.find('.image-block__pagination-item').eq(0).addClass('image-block__pagination-item_active');
	}
	action.initSlider = () => {
		if ($(window).width() < 768) {
			if (! page.list.hasClass('slick-initialized')) {
				page.list.slick({
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					prevArrow: '<button type="button" class="slick-prev"></button>',
					nextArrow: '<button type="button" class="slick-next"></button>',
				})
				.on('beforeChange', function(e,s,c,n) {
					action.images.lazyLoad($(this).find('[data-slick-index="' + n + '"]').find('.image-block__image'));
				});
			}
		} else {
			if (page.list.hasClass('slick-initialized'))
				page.list.slick('unslick');
		}
	}

	page.images.each(function() {
		var items = $(this).find('.image-block__item');
		if (page.pagination.length) {
			for (let i = 0; i < items.length; i++)
				$(this).find('.image-block__pagination').append('<li class="image-block__pagination-item"></li>');

			$(this).find('.image-block__pagination-item').eq(0).addClass('image-block__pagination-item_active');
		}
	});

	page.images
		.mousemove( action.images.onMousemove )
		.mouseleave( action.images.onMouseleave );

	// $(window).resize( action.initSlider );
	// action.initSlider();

	page.list.find('.slick-arrow').click(function(e){
		e.preventDefault();
		e.stopImmediatePropagation();
	});
});